// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-card[data-v-c0ac7a4e]{border-radius:var(--sds-b-radius-4);width:100%}.summary-card .summary-title[data-v-c0ac7a4e]{color:var(--sds-pink-600)}.summary-card .summary-body[data-v-c0ac7a4e]{gap:12px}.summary-card .summary-body .summary-line[data-v-c0ac7a4e]{border-bottom:1px dashed #d8d8df}", ""]);
// Exports
module.exports = exports;
